export const formPlaceholderConfig = Array(7)
  .fill('input')
  .concat(Array(2).fill('textarea'))
  .concat(Array(4).fill('input'));

export const profileFormPlaceholderConfig = Array(4).fill('input').concat(Array(1).fill('textarea'));
